import React, { useState, useEffect} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
    Modal,
    ModalBody,
    ModalHeader,
    Button,
    ButtonToolbar,
    Row,
    Col,
} from "reactstrap";
import { Form, Field } from "react-final-form";
import axios from "axios";
import PropTypes from 'prop-types';
import { sendFlashMessage } from "@/shared/components/flash";
import { getProgramAction } from "@/redux/actions/programActions";
import getPfiConnection from '@/service/program/getPfiConnection';
import AlertPopup from '@/shared/components/modal/alertModal/AlertPopup';
import getUserStatusList from '@/service/getUserStatuses';
import renderToggleButtonField from "@/shared/components/form/ToggleButton";


const PfiModal = ({ isOpen, toggle, program, userTypes, dispatch, organization }) => {
    const [loading, setLoading] = useState(true);
    const [userStatusLoading, setUserStatusLoading] = useState(true);
    const [connectionStatus, setConnectionStatus] = useState(null);
    const [pfiSettings, setPfiSettings] = useState(null);
    const [userStatuses, setUserStatuses] = useState([]);

    const [alertMessage, setAlertMessage] = useState('')
    const [isAlertOpen, setIsAlertOpen] = useState(false)
    const DEFAULT_PFI_VALUES = {
        enable_pfi: false,
        identity: "",
        shared_secret_code: "",
        customer_number: "",
    };
    useEffect( () => {
        if( organization?.id )
        {
            getPfiConnection( organization.id, program.id )
            .then( data => {
                setPfiSettings(data);
                setLoading(false);
            })
        }
    }, []);

    useEffect( () => {
        if( organization?.id )
        {
            getUserStatusList( organization.id )
                .then(list => {
                    setUserStatuses([
                        ...list.map(status => ({ value: status.id, label: status.status }))
                    ]);
                    setUserStatusLoading(false);
                });
        }
    }, [pfiSettings]);

    const onSubmitForm = async (values) => {
        setLoading(true);
        try {
            if(pfiSettings.id){
                const payload = {
                    ...DEFAULT_PFI_VALUES,
                    ...values
                };
                const response = await axios.put(`/pfi/${pfiSettings.id}`, payload);
                setLoading(false);
                if (response.status === 200) {
                    setPfiSettings(response.data);
                    dispatch(sendFlashMessage("PFI configuration has been updated", "alert-success", "top"));
                    dispatch(getProgramAction(organization.id, program.id));
                    toggle(); // Close the modal on success
                }
            }else{
                const response = await axios.put(`/organization/${organization.id}/program/${program.id}/pfi`, values);
                setLoading(false);
                if (response.status === 200){
                    setPfiSettings(response.data);
                    dispatch(sendFlashMessage("PFI configuration has been created", "alert-success", "top"));
                    dispatch(getProgramAction(organization.id, program.id));
                    toggle(); // Close the modal on success
                }else{
                    dispatch(sendFlashMessage("PFI configuration could not be created", "alert-danger", "top"));
                    dispatch(getProgramAction(organization.id, program.id));
                    toggle(); // Close the modal on success
                }
            }

        } catch (error) {
            setLoading(false);
            dispatch(sendFlashMessage("PFI configuration could not be updated", "alert-danger", "top"));
            console.error(`API error: ${error.message}`);
        }
    };


    const verifyConnection = async (values) => {
        let missingFields = [];

        if (!values.customer_number) {
            missingFields.push("Customer Number");
        }

        if (!values.identity) {
            missingFields.push("Identity");
        }

        if (!values.shared_secret_code) {
            missingFields.push("Shared Secret Code");
        }

        if (missingFields.length > 0) {
            dispatch(
                sendFlashMessage(
                    `${missingFields.join(", ")} field(s) are required for connection verification`,
                    "alert-danger",
                    "top"
                )
            );
            return;
        }
            // if(!pfiSettings.id){
            //     dispatch(sendFlashMessage("PFI configuration does not exist", "alert-danger", "top"));
            // }else{
                try {
                    const response = await axios.put(`/organization/${organization.id}/program/${program.id}/pfi/connection`, values)
                      .then( (response) => {
                            let messages =[];
                           console.log(response)
                            if (response?.data?.status === 200 && response?.data?.message === "OK") {
                                
                                messages.push('PFI configuration connection verified');
                                setAlertMessage(messages.join('<br/>'));
                                alertToggle();
                            } else {
                                //console.log(response)
                                dispatch(sendFlashMessage(response.data.message, "alert-danger", "top"));
                            }
                      })
                      .catch( error => {
                          console.log(error);
                      })
                } catch (error) {
                    console.log(error)
                }
            //}
        };
    
        const removeConnection = async (values) => {
            if(!pfiSettings.id){
                dispatch(sendFlashMessage("PFI configuration does not exist", "alert-danger", "top"));
            }else{
                try {
                    const response = axios.delete(`/pfi/delete/${pfiSettings.id}`)
                      .then( (response) => {
                          setPfiSettings({});
                          dispatch(sendFlashMessage("PFI configuration has been removed", "alert-success", "top"));
                          toggle(); // Close the modal on success
                      })
                      .catch( error => {
                          console.log(error);
                      })
                } catch (error) {
                    console.log(error)
                }
            }
        }
    
        const alertToggle = () => {
            setIsAlertOpen(prevState => !prevState)
        }

    if( loading || userStatusLoading) return 'Loading...'

    return (

        <Modal isOpen={isOpen} toggle={toggle} className="modal-program modal-lg theme-light ltr-support">
            <AlertPopup isOpen={isAlertOpen} title="Verify connection" message={alertMessage} toggle={alertToggle} />
            
            <Form
                onSubmit={onSubmitForm}
                initialValues={{
                    ...DEFAULT_PFI_VALUES,
                    ...pfiSettings
                }}
                keepDirtyOnReinitialize
            >
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <ModalHeader toggle={toggle} className='w100' >
                            <Row className='w100'>
                                <Col md="6" lg="6" xl="6" className='text-left'>
                                    PFI Configurations
                                </Col>
                                <Col md="6" lg="6" xl="6" className='text-right'>
                                  <ButtonToolbar className="modal__footer flex justify-content-right w100">
                                    <Button outline color="secondary" onClick={toggle} className="mr-3">
                                        Close
                                    </Button>
                                    {' '}
                                    <Button
                                        type="submit"
                                        disabled={loading}
                                        color="primary" >
                                        Save Changes
                                    </Button>
                                  </ButtonToolbar>
                                </Col>
                            </Row>
                        </ModalHeader>
                        <ModalBody>
                            <fieldset>
                                <legend>PFI Configurations</legend>
                                <Row>
                                    <Col className="col-md-3 col-lg-4 col-xl-4">
                                        <div className="form__form-group">
                                            <div className="form__form-group-field">
                                                <span
                                                className="form__form-group-label text-left mt-3"
                                                style={{ width: "200%" }}
                                                >
                                                Enable PFI
                                                </span>
                                                <Field
                                                name="enable_pfi"
                                                component={renderToggleButtonField}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <div className="form-group text-left">
                                            <label htmlFor="customer_number">Customer Number</label>
                                            <Field
                                                name="customer_number"
                                                component="input"
                                                type="text"
                                                className="form-control"
                                                id="customer_number"
                                               
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <div className="form-group text-left">
                                            <label htmlFor="identity">Identity</label>
                                            <Field
                                                name="identity"
                                                component="input"
                                                type="text"
                                                className="form-control"
                                                id="identity"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="6">
                                        <div className="form-group text-left">
                                            <label htmlFor="shared_secret_code">Shared Secret Code</label>
                                            <Field
                                                name="shared_secret_code"
                                                component="input"
                                                type="text"
                                                className="form-control"
                                                id="shared_secret_code"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                <Col md="12">
                                    <div className="form-group">
                                        <Button
                                            type="button"
                                            color="primary"
                                            onClick={() => verifyConnection(values)}
                                            disabled={loading}
                                        >
                                            Verify Connection
                                        </Button>

                                        &nbsp;
                                        <Button
                                            type="button"
                                            color="secondary"
                                            onClick={() => removeConnection(values)}
                                            disabled={loading}
                                        >
                                            Remove Connection
                                        </Button>

                                        {connectionStatus && (
                                            <p className={connectionStatus === "Connection successful" ? "text-success" : "text-danger"}>
                                                {connectionStatus}
                                            </p>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                            </fieldset>
                        </ModalBody>
                    </form>
                )}
            </Form>
        </Modal>
    );
};

PfiModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    program: PropTypes.object.isRequired,
    userTypes: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    organization: PropTypes.object.isRequired,
};

export default withRouter(
    connect((state) => ({
        organization: state.organization,
        userTypes: state.userTypes,
        program: state.program,
        theme: state.theme,
        rtl: state.rtl,
    }))(PfiModal)
);
